import axios from 'axios';

// ایجاد کلاینت axios برای همه درخواست‌ها
const api = axios.create({
  baseURL: 'https://api.pythonteek.com',
});

// اضافه کردن accessToken به همه درخواست‌ها
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refreshToken');

      if (!refreshToken) {
        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(error);
      }

      try {
        const res = await axios.post(
          'https://api.pythonteek.com/student/api/token/refresh/',
          { refresh: refreshToken }
        );

        if (res.status === 200 && res.data.access) {
          localStorage.setItem('accessToken', res.data.access);
          originalRequest.headers['Authorization'] = `Bearer ${res.data.access}`;
          return api(originalRequest);
        } else {
          localStorage.clear();
          window.location.href = '/login';
          return Promise.reject(error);
        }
      } catch (refreshError) {
        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

// تابع لاگین دانشجو
export const studentAuthAPI = {
  login: async (username_or_phone_number, password) => {
    try {
      const res = await axios.post(
        'https://api.pythonteek.com/student/api/v1/student-login/',
        {
          username_or_phone_number,
          password,
        }
      );

      if (res.status === 200) {
        localStorage.setItem('accessToken', res.data.access);
        localStorage.setItem('refreshToken', res.data.refresh);
      }

      return res.data;
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  },
  logout: () => {
    localStorage.clear();
    window.location.href = '/login';
  },
};

export default api;